var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#2D3136"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6844 22.3265C15.4767 22.3265 15.2758 22.2997 15.1084 22.2395C12.5499 21.3621 8.48438 18.2477 8.48438 13.6464C8.48438 11.3022 10.3798 9.40002 12.7106 9.40002C13.8425 9.40002 14.9007 9.84207 15.6844 10.6324C16.468 9.84207 17.5262 9.40002 18.6581 9.40002C20.9889 9.40002 22.8844 11.3089 22.8844 13.6464C22.8844 18.2544 18.8189 21.3621 16.2604 22.2395C16.0929 22.2997 15.892 22.3265 15.6844 22.3265ZM12.7106 10.4047C10.9357 10.4047 9.48903 11.8581 9.48903 13.6464C9.48903 18.2209 13.8894 20.766 15.4366 21.2951C15.5571 21.3353 15.8183 21.3353 15.9389 21.2951C17.4794 20.766 21.8864 18.2276 21.8864 13.6464C21.8864 11.8581 20.4397 10.4047 18.6648 10.4047C17.6468 10.4047 16.7024 10.8802 16.0929 11.704C15.9054 11.9585 15.4767 11.9585 15.2892 11.704C14.6663 10.8735 13.7287 10.4047 12.7106 10.4047Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHeart);
export default __webpack_public_path__ + "static/media/Icons-heart.c1e73474669a489337b3e50243086eaf.svg";
export { ForwardRef as ReactComponent };